import {
  SupervisorAccount,
  MonetizationOn,
  ReceiptLong,
  ManageAccounts,
  StorefrontOutlined,
  // AccountBalanceWalletOutlined,
  // PendingActionsOutlined,
  // FactCheckOutlined,
  ListAltOutlined,
  Handyman,
  SnippetFolder,
  DriveFolderUpload,
  Dashboard,
  InsertDriveFile,
  TrendingUp,
  CallReceived,
  CallMade,
  PendingActions,
  Edit,
  CalendarMonth
} from "@mui/icons-material";
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import SummarizeIcon from '@mui/icons-material/Summarize';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import AddBusinessIcon from '@mui/icons-material/AddBusiness';
import RouteIcon from '@mui/icons-material/Route';
import SettingsIcon from '@mui/icons-material/Settings';
import BrandingWatermarkIcon from '@mui/icons-material/BrandingWatermark';
import TollIcon from '@mui/icons-material/Toll';
import PixIcon from '@mui/icons-material/Pix';
import SettingsAccessibilityIcon from '@mui/icons-material/SettingsAccessibility';
import PermIdentityIcon from '@mui/icons-material/PermIdentity';
// import AssuredWorkloadIcon from '@mui/icons-material/AssuredWorkload';
import BookIcon from '@mui/icons-material/Book';
import ArticleIcon from '@mui/icons-material/Article';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import ApartmentIcon from '@mui/icons-material/Apartment';
import PaymentIcon from '@mui/icons-material/Payment';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import { ROLES, SCOPE_IDENTIFIERS, prefixV3 } from "../../utils/constants";
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import AssessmentIcon from '@mui/icons-material/Assessment';
// ----------------------------------------------------------------------

const paths = [
  // {
  //   title: "Dashboard",
  //   path: prefixV3 + "/dashboard",
  //   icon: <Dashboard fontSize="inherit" />,
  // },
  {
    title: "Dashboard",
    icon: <Dashboard fontSize="inherit" />,
    scope: SCOPE_IDENTIFIERS.TRANSACTION,
    sub: [
      {
        title: "Transactions",
        path: prefixV3 + "/transactions",
        icon: <ReceiptLong fontSize="inherit" />,
      },
      {
        title: "Reports",
        icon: <SummarizeIcon fontSize="inherit" />,
        link: process.env.REACT_APP_REPORTS_LINK,
      }
    ]
  },

  {
    title: "Finance",
    icon: <MonetizationOn fontSize="inherit" />,
    scope: [SCOPE_IDENTIFIERS.PAYOUT_UPLOAD_FILE, SCOPE_IDENTIFIERS.PAYOUT_VIEW_DATA],
    sub: [
      // {
      //   title: "Reconciliations",
      //   icon: <ListAlt fontSize="inherit" />,
      //   scope: SCOPE_IDENTIFIERS.RECON_SETTLEMENT,
      //   sub: [
      //     {
      //       title: "Mismatched",
      //       icon: <RuleIcon fontSize="inherit" />,
      //       path: prefixV3 + "/reconcile/mismatched",
      //     },
      //     {
      //       title: "Chargeback",
      //       icon: <FlipCameraAndroidIcon fontSize="inherit" />,
      //       path: prefixV3 + "/reconcile/chargeback",
      //     },
      //     {
      //       title: "Reconciled",
      //       icon: <CreditScoreIcon fontSize="inherit" />,
      //       path: prefixV3 + "/reconcile/reconciled",
      //     }
      //   ]
      // },
      // {
      //   title: "Settlement",
      //   icon: <AccountBalanceIcon fontSize="inherit" />,
      //   scope: SCOPE_IDENTIFIERS.RECON_SETTLEMENT,
      //   sub: [
      //     {
      //       title: "Pending",
      //       icon: <PendingActions fontSize="inherit" />,
      //       path: prefixV3 + "/settlements/pending",
      //     },
      //     {
      //       title: "Approved",
      //       icon: <TaskOutlined fontSize="inherit" />,
      //       path: prefixV3 + "/settlements/approved",
      //     },
      //     {
      //       title: "Rejected",
      //       icon: <DangerousIcon fontSize="inherit" />,
      //       path: prefixV3 + "/settlements/rejected",
      //     }
      //   ]
      // },
      // {
      //   title: "Report",
      //   icon: <SummarizeIcon fontSize="inherit" />,
      //   sub: [
      //     // {
      //     //   title: "Reports",
      //     //   icon: <AssessmentOutlined fontSize="inherit" />,
      //     //   path: prefixV3 + "/report/reports",
      //     //   scope: SCOPE_IDENTIFIERS.REPORT,
      //     // },
      //     // {
      //     //   title: "Security Deposit",
      //     //   icon: <PaymentsIcon fontSize="inherit" />,
      //     //   path: prefixV3 + "/report/deposit",
      //     //   scope: SCOPE_IDENTIFIERS.SECURITY_DEPOSIT,
      //     // },
      //     {
      //       title: "Merchant Payout Info",
      //       icon: <ImportContactsOutlined fontSize="inherit" />,
      //       path: prefixV3 + "/report/merchant-payout",
      //       scope: SCOPE_IDENTIFIERS.MERCHANT_PAYOUT_INFO,
      //     }
      //   ]
      // },
      // {
      //   title: "Daily Run",
      //   path: prefixV3 + "/daily-run",
      //   icon: <Analytics fontSize="inherit" />,
      // },
      // {
      //   title: "Import Data",
      //   path: prefixV3 + "/operations/upload-acquirer-file",
      //   icon: <DriveFolderUpload fontSize="inherit" />,
      //   scope: SCOPE_IDENTIFIERS.PAYOUT_UPLOAD_FILE,
      //   role: ROLES.UPLOAD_FILE,
      //   restrictedTo: ['BT'],
      // },
      {
        title: "Payout pipeline manual",
        path: prefixV3 + "/operations/payout-pipeline-manual",
        icon: <Handyman fontSize="inherit" />,
        scope: SCOPE_IDENTIFIERS.PAYOUT_UPLOAD_FILE,
        role: ROLES.UPLOAD_FILE
      },
      // {
      //   title: "Payout Pipeline Tracker",
      //   path: prefixV3 + "/operations/payout-pipeline-tracker",
      //   icon: <ManageSearchIcon fontSize="inherit" />,
      // },
      {
        title: "Payout Ingestor",
        path: prefixV3 + "/operations/payout-ingestor",
        icon: <ManageSearchIcon fontSize="inherit" />,
        scope: SCOPE_IDENTIFIERS.PAYOUT_VIEW_DATA,
      },
      {
        title: "Payout Reconciliation",
        path: prefixV3 + "/operations/payout-reconciliation",
        icon: <ManageSearchIcon fontSize="inherit" />,
        scope: SCOPE_IDENTIFIERS.PAYOUT_VIEW_DATA,
      },
      {
        title: "Payout Settlement",
        path: prefixV3 + "/operations/payout-settlement",
        icon: <ManageSearchIcon fontSize="inherit" />,
        scope: SCOPE_IDENTIFIERS.PAYOUT_VIEW_DATA,
      },
      //  {
      //   title: "Merchant Bank Detail",
      //   path: prefixV3 + "/operations/merchant-bank",
      //   icon: <AccountBalanceIcon fontSize="inherit" />,
      //  },
    ]
  },

  {
    title: "Finance New",
    icon: <MonetizationOn fontSize="inherit" />,
    sub: [
      {
        title: "Acquirer Files",
        path: prefixV3 + "/finance/acquirer-files",
        icon: <InsertDriveFile fontSize="inherit" />,
        scope: SCOPE_IDENTIFIERS.ACQUIRER_FILE,
        role: ROLES.VIEW
      },
      {
        title: "Bank Statements",
        path: prefixV3 + "/finance/bank-statements",
        icon: <AccountBalanceIcon fontSize="inherit" />,
        scope: SCOPE_IDENTIFIERS.BANK_STATEMENT,
        role: ROLES.VIEW,
      },
      // {
      //   title: "PayNow Duplicate",
      //   path: prefixV3 + "/finance/paynow-duplicate",
      //   icon: <ContentCopyIcon fontSize="inherit" />,
      //   scope: SCOPE_IDENTIFIERS.PAYNOW_DUPLICATE,
      //   role: ROLES.VIEW,
      //   restrictedTo: ['BT'],
      // },
      {
        title: "Incoming",
        path: prefixV3 + "/finance/incoming",
        icon: <CallReceived fontSize="inherit" />,
      },
      {
        title: "Outgoing",
        path: prefixV3 + "/finance/outgoing",
        icon: <CallMade fontSize="inherit" />,
      },
      {
        title: "Pending",
        path: prefixV3 + "/finance/pending",
        icon: <PendingActions fontSize="inherit" />,
      },
      {
        title: "Adjustment",
        path: prefixV3 + "/finance/adjustment",
        icon: <Edit fontSize="inherit" />,
        scope: SCOPE_IDENTIFIERS.ADJUSTMENT,
        role: ROLES.VIEW,
      },
      {
        title: "Exception Handling",
        path: prefixV3 + "/finance/exception-handling",
        icon: <PendingActions fontSize="inherit" />,
        scope: SCOPE_IDENTIFIERS.EXCEPTION_HANDLING,
        role: ROLES.VIEW,
      },
      {
        title: "Merchant Reports",
        path: prefixV3 + "/finance/merchant-reports",
        icon: <SummarizeIcon fontSize="inherit" />,
      },
      {
        title: "Monthly Reports",
        path: prefixV3 + "/finance/monthly-reports",
        icon: <AssessmentIcon fontSize="inherit" />,
      },
      {
        title: "MAS Reports",
        path: prefixV3 + "/finance/mas-reports",
        icon: <ArticleIcon fontSize="inherit" />,
        restrictedTo: ['BT'],
      },
      {
        title: "Insights",
        path: prefixV3 + "/finance/insights",
        icon: <TrendingUp fontSize="inherit" />,
        restrictedTo: ['BT'],
      },
      {
        title: "Exchange Rates",
        path: prefixV3 + "/finance/exchange-rates",
        icon: <MonetizationOn fontSize="inherit" />,
        scope: SCOPE_IDENTIFIERS.EXCHANGE_RATE,
        role: ROLES.VIEW,
        restrictedTo: ['BT'],
      },
    ]
  },

  {
    title: "Operations",
    icon: <AccountTreeIcon fontSize="inherit" />,
    sub: [
      {
        title: "Onboarding",
        path: prefixV3 + "/operations/onboarding",
        icon: <AddBusinessIcon fontSize="inherit" />,
        // scope: SCOPE_IDENTIFIERS.ONBOARDING,
      },
      {
        title: "Business Entity",
        path: prefixV3 + "/operations/business-entity",
        icon: <AddBusinessIcon fontSize="inherit" />,
        scope: SCOPE_IDENTIFIERS.BUSINESS_ENTITY,
      },
      {
        title: "Merchant",
        path: prefixV3 + "/operations/merchant",
        icon: <StorefrontOutlined fontSize="inherit" />,
        scope: SCOPE_IDENTIFIERS.MERCHANT,
      },
      {
        title: "Terminal",
        path: prefixV3 + "/operations/terminal",
        icon: <RouteIcon fontSize="inherit" />,
        scope: SCOPE_IDENTIFIERS.TERMINAL,
      },

      {
        title: "Bank Account",
        path: prefixV3 + "/operations/bank-account",
        icon: <AccountBalanceIcon fontSize="inherit" />,
        scope: SCOPE_IDENTIFIERS.BANK_ACCOUNT,
      },
      {
        title: "Merchant Payout Info",
        path: prefixV3 + "/operations/merchant-payout-info",
        icon: <ListAltOutlined fontSize="inherit" />,
        scope: SCOPE_IDENTIFIERS.MERCHANT_PAYOUT_INFO,
      },

      { divider: true },

      // {
      //   title: "Click&Scan2Pay",
      //   icon: <CreditCardIcon fontSize="inherit" />,
      //   path: prefixV3 + "/operations/quick-payment",
      //   scope: SCOPE_IDENTIFIERS.QUICK_PAYMENT,
      // },
      // {
      //   title: "PayNow Descriptor",
      //   path: prefixV3 + "/operations/paynow-descriptor",
      //   icon: <ListAltOutlined fontSize="inherit" />,
      //   scope: SCOPE_IDENTIFIERS.PAYNOW_DESCRIPTOR,
      //   restrictedTo: ['BT'],
      // },
      {
        title: "MPI",
        path: prefixV3 + "/operations/mpi",
        icon: <ApartmentIcon fontSize="inherit" />,
        scope: SCOPE_IDENTIFIERS.MPI,
      },

      { divider: true },

      {
        title: "Test Payment Page",
        path: prefixV3 + "/operations/test-payment-page",
        icon: <PaymentIcon fontSize="inherit" />,
      },
      {
        title: "Data File Generation",
        path: prefixV3 + "/operations/data-file-generation",
        icon: <SnippetFolder fontSize="inherit" />,
        scope: SCOPE_IDENTIFIERS.TRANSACTION,
      },
      {
        title: "Download from S3",
        path: prefixV3 + "/operations/download-from-s3",
        icon: <CloudDownloadIcon fontSize="inherit" />,
        scope: SCOPE_IDENTIFIERS.TRANSACTION,
        restrictedTo: ['BT'],
      },
      {
        title: "No Payout Day",
        path: prefixV3 + "/operations/no-payout-day",
        icon: <CalendarMonth fontSize="inherit" />,
        scope: SCOPE_IDENTIFIERS.NO_PAYOUT_DAY,
        role: ROLES.VIEW,
        restrictedTo: ['BT'],
      },
      // {
      //   title: "Department",
      //   path: prefixV3 + "/operations/department",
      //   icon: <MeetingRoomIcon fontSize="inherit" />,
      // },
      // {
      //   title: "PayNow Descriptor",
      //   path: prefixV3 + "/operations/paynow-descriptor",
      //   icon: <ListAltOutlined fontSize="inherit" />,
      // },
      // {
      //   title: "Entity",
      //   path: prefixV3 + "/operations/oxygen7-entity",
      //   icon: <CorporateFareIcon fontSize="inherit" />,
      // },
    ]
  },

  {
    title: "Gateway configuration",
    icon: <SettingsIcon fontSize="inherit" />,
    scope: [SCOPE_IDENTIFIERS.PAYMENT_HOST, SCOPE_IDENTIFIERS.PAYMENT_BRAND, SCOPE_IDENTIFIERS.PAYMENT_METHOD],
    sub: [
      {
        title: "Payment host",
        icon: <PixIcon fontSize="inherit" />,
        path: prefixV3 + "/operations/payment-host",
        scope: SCOPE_IDENTIFIERS.PAYMENT_HOST,
      },
      {
        title: "Payment brand",
        icon: <BrandingWatermarkIcon fontSize="inherit" />,
        path: prefixV3 + "/operations/payment-brand",
        scope: SCOPE_IDENTIFIERS.PAYMENT_BRAND,
      },
      {
        title: "Payment method",
        icon: <TollIcon fontSize="inherit" />,
        path: prefixV3 + "/operations/payment-method",
        scope: SCOPE_IDENTIFIERS.PAYMENT_METHOD,
      },
    ]
  },

  {
    title: "Portal Management",
    icon: <SupervisorAccount fontSize="inherit" />,
    scope: [SCOPE_IDENTIFIERS.ACCOUNT, SCOPE_IDENTIFIERS.GROUP, SCOPE_IDENTIFIERS.MERCHANT_USER, SCOPE_IDENTIFIERS.NOTIFICATIONS, SCOPE_IDENTIFIERS.AUDIT_LOGS],
    sub: [
      {
        title: "Admin User",
        path: prefixV3 + "/admin/account",
        icon: <ManageAccounts fontSize="inherit" />,
        scope: SCOPE_IDENTIFIERS.ACCOUNT,
      },
      // {
      //   title: "Admin User GW2",
      //   path: prefixV3 + "/admin/account-v2",
      //   icon: <ManageAccounts fontSize="inherit" />,
      //   scope: SCOPE_IDENTIFIERS.ACCOUNT,
      // },
      {
        title: "Admin Role",
        path: prefixV3 + "/admin/roles-management",
        icon: <SettingsAccessibilityIcon fontSize="inherit" />,
        scope: SCOPE_IDENTIFIERS.GROUP,
      },

      { divider: true },

      {
        title: "Merchant User",
        path: prefixV3 + "/admin/merchant-user",
        icon: <PermIdentityIcon fontSize="inherit" />,
        scope: SCOPE_IDENTIFIERS.MERCHANT_USER,
      },
      // {
      //   title: "Merchant User GW2",
      //   path: prefixV3 + "/admin/merchant-user-v2",
      //   icon: <PermIdentityIcon fontSize="inherit" />,
      //   scope: SCOPE_IDENTIFIERS.MERCHANT_USER,
      // },

      { divider: true },
      { divider: true },
      { divider: true },
      { divider: true },
      { divider: true },
      { divider: true },

      {
        title: "Notifications",
        path: prefixV3 + "/operations/product-update",
        icon: <ArticleIcon fontSize="inherit" />,
        scope: SCOPE_IDENTIFIERS.NOTIFICATIONS,
      },
      {
        title: "Audit Logs",
        path: prefixV3 + "/audit-logs",
        icon: <BookIcon fontSize="inherit" />,
        scope: SCOPE_IDENTIFIERS.AUDIT_LOGS,
      },
    ]
  },

  // {
  //   title: "Virtual Account",
  //   icon: <AssuredWorkloadIcon fontSize="inherit" />,
  //   scope: SCOPE_IDENTIFIERS.BUSINESS_ENTITY,
  //   sub: [
  //     {
  //       title: "Accounts",
  //       path: prefixV3 + "/virtual-account/accounts",
  //       icon: <AccountBalanceWalletOutlined fontSize="inherit" />,
  //       scope: SCOPE_IDENTIFIERS.BUSINESS_ENTITY,
  //     },
  //     {
  //       title: "Pending Transfer",
  //       path: prefixV3 + "/virtual-account/pending-transfer",
  //       icon: <PendingActionsOutlined fontSize="inherit" />,
  //     },
  //     {
  //       title: "Completed Transfer",
  //       path: prefixV3 + "/virtual-account/completed-transfer",
  //       icon: <FactCheckOutlined fontSize="inherit" />,
  //     },
  //   ]
  // },

  // {
  //   title: "Business Insight",
  //   path: prefixV3 + "/insight",
  //   icon: <InsightsIcon fontSize="inherit" />,
  // },
];

export default paths;
